import React from "react";
import { useTranslation } from "react-i18next";
import EAButton from "../shared/Buttons/EAButton";
import EATextField from "../shared/TextField/EATextField";
import { emailValidator, phoneValidator } from "../../../utils/formsValidation";
import { useForm } from "react-hook-form";
import ConsentInputs from "../FinalizePage/ConsentInputs/ConsentInputs";
import { InputsFinalize } from "../../models/InputsFinalize";

interface IProps {
  register: any;
  errors: any;
  control: any;
}

const FormPart2: React.FC<IProps> = ({ register, errors, control }: IProps) => {
  const { t } = useTranslation();

  const { setValue } = useForm<InputsFinalize>({});

  return (
    <>
      <h3 className="b2b-register-title">Podaj swoje dane do logowania</h3>
      <div className="b2b-register-two-input">
        <EATextField
          name="firstName"
          type="text"
          label="Imię"
          fullWidth
          register={register("firstName", { required: "To pole jest wymagane" })}
          error={!!errors.firstName}
          helperText={errors.firstName?.message as string}
        />
        <EATextField
          name="lastName"
          type="text"
          label="Nazwisko"
          fullWidth
          register={register("lastName", { required: "To pole jest wymagane" })}
          error={!!errors.lastName}
          helperText={errors.lastName?.message as string}
        />
      </div>
      <EATextField
        name="email"
        type="email"
        label="Adres email"
        fullWidth
        register={register("email", { ...emailValidator(true) })}
        error={!!errors.email}
        helperText={errors.email?.message as string}
      />
      <EATextField
        name="phone"
        type="text"
        label="Numer telefonu komórkowego"
        fullWidth
        register={register("phone", { ...phoneValidator(true) })}
        error={!!errors.phone}
        helperText={errors.phone?.message as string}
      />
      <div className="custom-checkbox-b2b__container">
        <ConsentInputs errors={errors} control={control} setValue={setValue} title={t("zgody")} />
      </div>
      <div className="b2b-register-next">
        <EAButton title="Załóż bezpłatne konto" inputType="submit" />
      </div>
    </>
  );
};

export default FormPart2;
